import { Box, Stack } from '@mui/material'
import React, { useEffect } from 'react'
import EngineeringIcon from '@mui/icons-material/Engineering';
import { customStyles, justifyCenter } from '../../../styles';
import { MainButton, SubTitle, Title } from '../../helpers';
import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';
import logo from '../../../assets/images/logo.png'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { animations } from '../../../utils/animations';
import { MainContainer } from '../../containers';

export const MaintenanceView = () => {
  const { colors: { main, secondary } } = customStyles
  const { fadeOut, fadeIn } = animations
  const [counter, setCounter] = useState(5)
  const navigate = useNavigate()
  const [handleAnimation, setHandleAnimation] = useState(false)
  useEffect(() => {
    const count = setInterval(() => {
      const newValue = Math.max(counter - 1, 0)
      setCounter(newValue)
    }, 1000);

    let timer
    if(counter === 0) {
      setHandleAnimation(true)
      timer = setTimeout(() => {
        navigate('/')
      }, 1500);      
    }
    return () => {
      clearInterval(count)
      clearTimeout(timer)
    }
  }, [counter])


  const handleNavigate = () => {
    navigate(-1)
  }
  return (
    <MainContainer sx={{ height: '100vh' }}>

    <Stack width="100%" height="100vh" sx={{...justifyCenter, overflow: 'hidden', position: 'relative'}} className={handleAnimation ? fadeOut : fadeIn}>
      <figure>
        <img src={logo} alt="global" width="300px"/>
      </figure>
      <ConstructionOutlinedIcon sx={{
        fontSize: 500,
        color: main,
        position: 'absolute',
        left: '50%',
        bottom: 0,
        transform: 'translateX(-50%)',
        zIndex: -3,
        opacity: .1,
        animationIterationCount: 'infinite'
      }} className={animations.pulse}/>
      <Title align="center" color={main} text={`404 Pagina no encontrada`}/>
      <SubTitle align="center" color={main} text={`Sera redireccionado a la pagina principal en:`}/>
      <SubTitle align="center" color={main} text={`${counter} segundos`} className={handleAnimation}/>
      <MainButton variant="contained" text="Ir" onClick={handleNavigate}/>
    </Stack>
      </MainContainer>
  )
}
